import { render, staticRenderFns } from "./InsurReport.vue?vue&type=template&id=67d67668&"
import script from "./InsurReport.vue?vue&type=script&lang=js&"
export * from "./InsurReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports